import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'

export default [
  set(state`selectr.${props`namespace`}.optionsClosed`, props`close`)
]
